import React from "react";
import EAChoiceChip from "./EAChoiceChip";
import "./EAChoiceChip.scss";
import EASkeletonLoader from "../EASkeletonLoader";

interface Option {
  value: string;
  label: string;
  icon?: React.ReactNode;
}

interface IProps {
  options: Option[];
  selectedValue: string;
  onSelect: (value: string, label: string) => void;
  chipSize?: "small" | "medium";
  loading?: boolean;
  width?: string;
}

const EAMultipleChoiceChipSelector: React.FC<IProps> = ({
  options,
  selectedValue,
  onSelect,
  chipSize = "medium",
  loading = false,
  width = "",
}) => {
  const handleChipClick = (value: string, label: string) => {
    onSelect(value, label);
  };

  const hasSelection = !!selectedValue; // Sprawdza, czy istnieje zaznaczony chip

  if (loading) {
    return <EASkeletonLoader height="100px" />;
  }

  return (
    <div className={`multiple-choice-chip-selector ${hasSelection ? "has-selection" : ""}`} style={{ width: width }}>
      {options.length > 0 ? (
        <>
          {options.map((option) => (
            <EAChoiceChip
              key={option.value}
              label={option.label}
              isSelected={selectedValue === option.value}
              size={chipSize}
              onClick={() => handleChipClick(option.value, option.label)}
              fullWidth
              icon={option.icon}
            />
          ))}
        </>
      ) : (
        <p>Brak opcji do wyboru.</p>
      )}
    </div>
  );
};

export default EAMultipleChoiceChipSelector;
